import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { login } from "../services/users";
import { useGlobalState } from "../context/GlobalStateContext";

function LoginForm() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const { sessionInfo, sendSocketMessage } = useGlobalState();

  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/characters/list");
    }
  });

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(""); // Reset errore precedente
    try {
      const response = await login(username, password);
      localStorage.setItem("token", response.token);
      sendSocketMessage("LOGIN_USER", { username });
      sessionInfo.fetchUser();
      navigate("/characters/list");
    } catch (error) {
      // L'errore ora è un oggetto { status, message, data }
      setError(error.message || "Errore durante il login");
    }
  };

  return (
    <div className="login-form">
      <form onSubmit={handleLogin}>
        <div>
          <label htmlFor="username">Username:</label>
          <input
            id="username"
            type="text"
            value={username}
            autoComplete="current-username"
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>
        <div>
          <label htmlFor="password">Password:</label>
          <input
            id="password"
            type="password"
            value={password}
            autoComplete="current-password"
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <div className="login-form_buttons">
          <button type="submit">Login</button>
        </div>
        {error && <p style={{ color: "red" }}>{error}</p>}
        <div className="login-form_buttons">
          <Link to="/forgot-password">Recupera password</Link>
          <Link to="/new-user">Crea Utente</Link>
        </div>
      </form>
    </div>
  );
}

export default LoginForm;
